export const ACCEPT_LEAD = '/solleads/accept-lead'
